module.exports = __webpack_public_path__ + "img/product5p.40a67a7c.jpg";